var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-notice-bar',{attrs:{"scrollable":false}},[_vm._v("\n    您访问的页面未找到！\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }